<ftr-side-nav-shell
  [displayMode]="displayMode"
  [expanded]="expanded"
  [isLoading]="isLoading"
  [isOpened]="isOpened"
  [navGroups]="navGroups()"
  [footerItems]="footerItems()"
  [providerType]="providerType()"
  (sideBarToggled)="sideBarToggled.emit()"
  (expandedToggled)="expandedToggled.emit()"
>
  <a sideNavHeader class="public-side-nav-logo" [routerLink]="['/']" aria-label="Go to home">
    <ftr-logo
      [size]="expanded ? logoSize.Small : logoSize.ExtraSmall"
      [theme]="expanded ? logoTheme.ThemedWhite : logoTheme.ThemedNoText"
      [fullWidth]="true"
    />
  </a>
  <ftr-user-and-org-dropdown
    sideNavSubHeader
    [collapsed]="!expanded"
    [displayMode]="displayMode"
    [style.width]="'100%'"
    (dropdownOpened)="onUserDropdownOpened()"
  />
</ftr-side-nav-shell>
